import { cn } from "@newxsystems/shared";
import { useId } from "react";
import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import { RichTextHtml } from "../../RichTextHtml";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  content,
  heading,
  parentClass,
  spacing,
  subheading,
}: IWysiwygBlockProps) => {
  const generatedId = useId();
  const headingId = heading ? `${generatedId}-heading` : undefined;
  const resolvedSpacing = spacing ?? "normal";
  const hasContent = Boolean(content);
  const hasHeader = Boolean(heading || subheading);

  if (!hasHeader && !hasContent) {
    return null;
  }

  return (
    <TootSectionShell
      className="mx-auto"
      rootClassName={parentClass}
      spacing={resolvedSpacing}
      tone="default"
    >
      {hasHeader ? (
        <header className="relative z-10 mb-7 border-b border-toot-grid-strong/70 pb-6 [overflow-wrap:anywhere]">
          {heading ? (
            <h2 className="toot-heading-section" id={headingId}>
              {heading}
            </h2>
          ) : null}
          {subheading ? (
            <RichTextHtml className={cn("prose", heading && "mt-4")} html={subheading} />
          ) : null}
        </header>
      ) : null}

      {hasContent ? (
        <>
          {!hasHeader ? (
            <div aria-hidden="true" className="mb-7 h-px bg-toot-grid-strong/70" />
          ) : null}
          <RichTextHtml className="prose" html={content} />
          <div aria-hidden="true" className="mt-7 h-px bg-toot-grid-strong/70" />
        </>
      ) : null}
    </TootSectionShell>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
